<template>
    <div class="warp">
        <div class="article-box">
            <div class="article-left"  v-for='item in detailList' :key="item.id">
                <div class="article-tit">{{item.title}}</div>
                <div class="article-time">{{item.create_time}}</div>
                <!-- <div class="art-img">
                    <img :src="item.picture.path" alt="">
                </div> -->
                <div class="art-content" v-html="content"></div>
            </div>
            <div class="article-right">
                <div class="art-top">
                    <div class="top-left" v-for='item in detailList' :key="item.id+'-'">
                        <div class="top-tit">阅读量</div>
                        <div class="top-content">{{item.view}}</div>
                    </div>
                    <!-- <div class="top-right" @click="clickShow()">
                        <div class="top-share">分享</div>
                        <i class="iconfont icon-fenxiang"></i>
                        <div class="top-right-show" v-show='judgeList.key == true'>使用“扫一扫”即可将网页分享至朋友圈。</div>
                        <div v-show='judgeList.key == true' id="qrcode"></div>
                        
                    </div> -->
                </div>
                <template v-if="preList.length > 0">
                    <div class="art-bottom" v-for='item in preList' :key= item.key v-show="preTrue.key == true">
                        <div class="art-next">上一篇</div>
                            <router-link :to="{path:'/informationdetails', query: {id: item.id, cid: item.category_id, mainid: mainid, subid: subid}}">{{item.title}}</router-link>
                        <div class="next-time">{{item.create_time}}</div>
                    </div>
                </template>
                <template v-if="nextList.length > 0">
                    <div class="art-bottom" v-for='item in nextList' :key= item.key v-show="nextTrue.key == true">
                        <div class="art-next">下一篇</div>
                            <router-link :to="{path:'/informationdetails', query: {id: item.id, cid: item.category_id, mainid: mainid, subid: subid}}">{{item.title}}</router-link>
                        <div class="next-time">{{item.create_time}}</div>
                    </div>
                </template>
            </div>
        </div>
      </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
     name:'Details',
     props:{
      mainid: {
        type: String
      },
      subid: {
		type: String
	  },
      judgeList:{
        type:Object,
        default:function(){
            key: false
        }
      },
      detailList:{
            type:Array,
            default:function(){
                return[{
                    id:1,
                    title:'直面量子计算威胁，数字货币在对抗中成长',
                    create_time:'2020-03-31 10:51:08',
                    // picture:{path:'http://p1.pstatp.com/large/pgc-image/5a1c566053c642f8a58b37b5c7d4df26'},
                }]
            }
        },
        content:{
            type: String
        },
        preList:{
            type: Array,
            default:function(){
                return[{
                    id:1,
                    title:'',
                    create_time:''
                }]
            }
        },
        preTrue:{
            type: Object,
            default:function(){
               key:true
            }
        },
        nextList:{
            type: Array,
            default:function(){
                return[{
                    id:1,
                    title:'',
                    create_time:''
                }]
            }
        },
        nextTrue:{
            type:Object,
            default:function(){
               key:true
            }
        },
     },
     created () {
        this.qrcode()
     },
     methods:{
         clickShow:function(){
            //  console.log(window.location.href)
            //  this.judgeList.key = !this.judgeList.key                    
           
         },
         qrcode:function () {
//            setTimeout(() => {
//                  let qrcode = new QRCode('qrcode', {
//                      width: 100,
//                      height: 100,
//                     //  text: 'http://www.runoob.com',
//                     //  text: 'http://www.hhyjy.qiaochang.com/informationdetails?id=33'
//                }) 
//             },2000)
        }
     }
}
</script>
<style>
  .icon-fenxiang{
    color: #932120;
  }
  .icon-fenxiang {
    color: #932120;
  }
</style>
